import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CirclePicker } from 'react-color';
import * as d3 from "d3";

class MyCustomForm extends React.Component {

	handleColorChange = (color, event) => {
		const { onChangeRouteStyle } = this.props;
		onChangeRouteStyle("color",color.hex);
		d3.select('#path').style('stroke', color.hex);
		d3.select('#extremity').style('stroke', color.hex);
		d3.select('#extremity').style('fill', color.hex);
		d3.select('#hr').style('stroke', color.hex);
		d3.select('#pace').style('stroke', color.hex);
	}

	handleThemeChange = (event, value) => {
		const { onChangeTheme } = this.props;
		onChangeTheme(value);
	}

	handleUnitChange = (event, value) => {
		const { onChangeUnit } = this.props;
		onChangeUnit(value);
	}

	handleStrokeWidthChange = (event, value) => {
		const { onChangeRouteStyle } = this.props;
		onChangeRouteStyle("strokeWidth",value);
		d3.select('#path').style('stroke-width', value);
	}

	render() {
		return (
			<div align="center" style={{ paddingTop: 30, display: 'flex', flexDirection: 'column' }}>
								<FormControl>
									<FormLabel component="legend" style={{ justifyContent:'center',marginBottom: 20 }}>Route</FormLabel>
									<div style={{ justifyContent:'center'}} ><CirclePicker color={this.props.style.route.color} onChange={this.handleColorChange} colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "white"]}>
									</CirclePicker></div>
								</FormControl>

								<FormControl style={{ marginTop: 0 }}>
									<FormLabel component="legend">Stroke width</FormLabel>
									<RadioGroup
										aria-label="strokeWidth"
										name="strokeWidth"
										style={{justifyContent:'center',display: 'flex', flexDirection: 'row'}}
										value={this.props.style.route.strokeWidth+''}
										onChange={this.handleStrokeWidthChange}
									>
										<FormControlLabel value='1' control={<Radio />} label="Thin" />
										<FormControlLabel value='3' control={<Radio />} label="Medium" />
										<FormControlLabel value='5' control={<Radio />} label="Large" />
									</RadioGroup>
								</FormControl>

								<FormControl style={{ marginTop: 40 }}>
									<FormLabel component="legend" >Theme</FormLabel>
									<RadioGroup
										aria-label="theme"
										name="theme"
										style={{justifyContent:'center',display: 'flex', flexDirection: 'row'}}
										value={this.props.style.theme}
										onChange={this.handleThemeChange}
									>
										<FormControlLabel value="light" control={<Radio />} label="Light" />
										<FormControlLabel value="dark" control={<Radio />} label="Dark" />
									</RadioGroup>
								</FormControl>

								<FormControl style={{ marginTop: 40 }}>
									<FormLabel component="legend">Unit</FormLabel>
									<RadioGroup
										aria-label="unit"
										name="unit"
										style={{justifyContent:'center',display: 'flex', flexDirection: 'row'}}
										value={this.props.unit}
										onChange={this.handleUnitChange}
									>
										<FormControlLabel value="km" control={<Radio />} label="Kilometres" />
										<FormControlLabel value="mi" control={<Radio />} label="Miles" />
									</RadioGroup>
								</FormControl>
							</div>
		)
	}
}

export default MyCustomForm;


// WEBPACK FOOTER //
// ./src/components/MyCustomForm.js